import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=50d8c02d&scoped=true&"
import script from "./ShareLink.vue?vue&type=script&lang=js&"
export * from "./ShareLink.vue?vue&type=script&lang=js&"
import style0 from "./ShareLink.vue?vue&type=style&index=0&id=50d8c02d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d8c02d",
  null
  
)

export default component.exports